import type { SkillCatalogSkill } from "connected-components/skills/types"

export function canDownloadSkill({ tier }: Pick<SkillCatalogSkill, "tier">): boolean {
  return tier !== "user"
}
